module.exports = __webpack_public_path__ + "static/img/bing_tu_bg_in.f4720a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2dmap/bing_tu_bg_in.png
// module id = YbON
// module chunks = 2